import { ReactNode } from 'react';

import { Box } from '@mui/material';

export const ButtonsContainer = ({ children }: { children: ReactNode }) => {
  return <Box sx={{ gap: 2, display: 'flex' }}>{children}</Box>;
};
